import type { IVideoPreviewSource } from "../../../../../entities/LivePreview/LivePreview.interface";

import { ITypeMedia } from "../../../../../interfaces/Artists";

import type {
  IGalleryBrowserUrl,
  IGalleryDisplay,
  IGalleryExternalVideo,
  IGalleryImage,
  IGalleryRemoteDevice,
  IGalleryVideo,
  IGalleryWebcam,
  IResourceBase,
} from "../Components/MediaGallery/MediaGallery.interface";

import type { IStudio } from "../interfaces/Studio.interface";

import type { IStudioArea } from "../interfaces/sub-interfaces/Areas.interface";

export type IResourceDB = IResourceBase &
  (
    | IGalleryWebcam
    | Omit<IGalleryVideo, "source">
    | IGalleryDisplay
    | Omit<IGalleryImage, "source">
    | IGalleryExternalVideo
    | IGalleryBrowserUrl
    | IGalleryRemoteDevice
  );

class Studio2Database {
  private data!: IStudio;

  constructor(studio: IStudio) {
    this.data = studio;

    this.replaceAreas();
  }

  private replaceResource(resource: IVideoPreviewSource): IResourceDB {
    if (resource.type === ITypeMedia.video) {
      const { source: _source, ...data } = resource;

      return data;
    }

    if (resource.type === ITypeMedia.image) {
      const { source: _source, ...data } = resource;

      return {
        ...data,

        type: ITypeMedia.image,

        settings: {
          name: resource.settings.name,

          directory: resource.settings.directory,
        },
      };
    }

    if (resource.type === ITypeMedia.browser) {
      return {
        id: resource.id,

        type: ITypeMedia.browser,

        origin: resource.origin,
      };
    }

    if (resource.type === ITypeMedia.camera) {
      const { source, ...data } = resource;

      return {
        ...data,

        type: ITypeMedia.camera,

        source: {
          deviceId: source.deviceId,

          groupId: source.groupId,

          kind: source.kind,

          label: source.label,
        },
      };
    }

    return resource;
  }

  private replaceAreas() {
    // `areas` puede venir `undefined` en escenas sin áreas (snapshots viejos /

    // escena en blanco): el tipo la declara requerida pero el modelo real no

    // siempre la inicializa. Sin el `?? []`, agregar una alerta a una escena

    // sin áreas tiraba `TypeError: undefined.map` al persistir el template.

    const areas = (this.data.areas ?? []).map((area) => {
      if (!area.media.resource) return area;

      const resource = this.replaceResource(area.media.resource);

      return {
        ...area,

        media: {
          ...area.media,

          resource,
        },
      };
    });

    this.data.areas = areas as IStudioArea[];
  }

  format() {
    return this.data;
  }
}

export default Studio2Database;
